import { Checkbox, FormControlLabel, FormHelperText } from "@mui/material";
import LabelledBox from "./LabelledBox";

/**
 * Checkbox group for picking items out of `availableItems`.
 * With `required`, the field reports itself invalid (blocking form submit) while nothing is selected.
 */
const CheckboxList = ({ id, label, selectedItems, onChange, sx, availableItems, disabled, required }) => {
    const onSelect = (item, selected) => {
        let newValue = [...selectedItems];

        if (selected) {
            newValue.push(item);
        }
        else {
            newValue = newValue.filter(room => room.id !== item.id);
        }

        newValue.sort();
        onChange(id, newValue, !required || newValue.length > 0);
    }

    return <LabelledBox
        label={label}
        sx={{
            display: 'flex',
            flexDirection: 'column',
            ...sx
        }}
    >
        {availableItems?.map(item => <FormControlLabel
            control={<Checkbox checked={selectedItems?.map(item => item.id).includes(item.id)} onChange={(evt) => onSelect(item, evt.target.checked)} disabled={disabled} />}
            label={item.name}
            key={item.id}
            labelPlacement="end"
            sx={{
                margin: '0px 5px'
            }}
        />)}
        {required && !selectedItems?.length && <FormHelperText error>Select at least one</FormHelperText>}
    </LabelledBox>;
}

export default CheckboxList;